import { disputeSource } from "@redotech/redo-dispute-db-schema/dispute-definition";
import * as z from "zod";

export const submitDisputeEvidence = {
  name: "submitDisputeEvidence" as const,
  input: z.object({
    disputeId: z.coerce.bigint(),
    source: z.enum(disputeSource),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
